import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

export type PixPaymentMethod = 'pix' | 'boleto' | 'card';

/**
 * Componente 100% visual do widget de pagamento PIX padronizado — sem nenhuma
 * chamada de API própria. Quem decide como gerar/confirmar o PIX é o
 * consumidor (via os eventos), o que permite reaproveitar o mesmo visual em
 * fluxos com lógica de backend diferente (ex.: crédito de carteira com
 * polling vs. contratação de plano sem polling).
 *
 * Pra fluxos que já usam `createWalletCreditPix`/`checkWalletCreditPayment`,
 * prefira `<rsm-pix-payment-panel>` (que já embute essa lógica e usa este
 * componente por baixo).
 */
@Component({
  selector: 'rsm-pix-payment-display',
  templateUrl: './pix-payment-display.component.html',
  styleUrls: ['./pix-payment-panel.component.scss'],
})
export class PixPaymentDisplayComponent implements OnChanges {
  @Input() paymentMethod: PixPaymentMethod = 'pix';
  @Input() qrCode = '';
  @Input() isGenerating = false;
  @Input() generated = false;
  @Input() confirmed = false;
  @Input() checking = false;
  @Input() timedOut = false;
  @Input() confirmedMessage = 'Pagamento confirmado! Saldo atualizado.';
  @Input() checkingMessage = 'Verificando pagamento... o saldo será creditado automaticamente assim que confirmado.';
  @Input() timedOutMessage = 'Aguardando confirmação do banco. O saldo será creditado automaticamente assim que o pagamento for detectado.';

  /** True enquanto o boleto está sendo gerado ou o PDF baixado. */
  @Input() isGeneratingBoleto = false;

  // Dados do boleto renderizado na tela (<rsm-boleto-view>).
  @Input() amount = 0;
  @Input() dueDate: string | Date | null = null;
  @Input() boletoDescription = 'Crédito de saldo em carteira';
  @Input() boletoDescriptionDetail = 'Recarga de créditos para uso na plataforma';
  @Input() boletoInfoLine = '';

  @Output() methodChange = new EventEmitter<PixPaymentMethod>();
  @Output() generate = new EventEmitter<void>();
  @Output() retry = new EventEmitter<void>();
  @Output() copy = new EventEmitter<void>();

  /** Pedido de gerar o boleto (cria o movimento e mostra o boleto na tela). */
  @Output() generateBoleto = new EventEmitter<void>();

  /** Pedido de baixar o boleto (PDF). Reusa a MESMA transação/QR do PIX. */
  @Output() downloadBoleto = new EventEmitter<void>();

  ngOnChanges(_changes: SimpleChanges): void {
    // reservado para extensões futuras
    this.selectMethod('boleto');
  }

  public selectMethod(method: PixPaymentMethod): void {
    if (this.paymentMethod === method) return;
    this.methodChange.emit(method);
  }
}
